import React from "react";

/**
 * One section of the client portal (`/compte`): icon tile, title, optional count, body.
 *
 * Its own module so a section that owns its data (public/pathways/PortalPathways.jsx) can
 * draw the same frame as the ones ClientPortal renders inline, without importing the page
 * that imports it. No "@/" imports: it resolves under Jest in every suite that mounts the
 * portal.
 *
 * @param {React.ComponentType} icon   lucide icon component
 * @param {string}              title  resolved heading
 * @param {number}              [count] shown when > 0
 * @param {string}              [testid] `data-testid` on the <section>
 */
const PortalSection = ({ icon: Icon, title, count, children, testid }) => (
  <section data-testid={testid} className="bg-eh-cream rounded-3xl border border-eh-border-soft p-6 md:p-8">
    <div className="flex items-center gap-3 mb-5">
      <span className="w-10 h-10 rounded-xl bg-eh-sage/15 text-eh-sage-deep flex items-center justify-center">
        <Icon size={20} />
      </span>
      <h2 className="font-display text-2xl text-eh-ink">{title}</h2>
      {count > 0 && <span className="ml-auto text-sm text-eh-muted">{count}</span>}
    </div>
    {children}
  </section>
);

export default PortalSection;
